import React, {useCallback, useEffect, useReducer, useState} from "react"

import {Cover, CoverPosition} from "../../../model2/task/properties/cover"
import CoverSelector from "../cover-selector/control-button"
import AttachmentsCollection from "../../../model2/attachment/attachments"
import CoverPositionSelector from "../position-selector/control-button"
import {EVENT_BUS_LAYOUT_ON_WIDTH_MAIN_CHANGE} from "../../../../layout/layout/bus-events"

type Props = {
    className?                  : string

    cover?                      : Cover
    attachments?                : AttachmentsCollection

    isFullWidth?                : boolean
    disabled?                   : boolean

    onCoverPositionSelected?    : {(position: CoverPosition): void}
    onCoverSelected?            : {(cover?: Cover): void}
}

const debug = false
// const debug = "CoverImageHolder"

export default function CoverImageHolder(props: Props) {

    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [showPopover, setShowPopover] = useState(false)

    const onResize = useCallback(() => {
        debug && console.log(debug, 'onResize', props)
        forceUpdate()
    }, [])

    useEffect(() => {
        if (props.cover) {
            const unsubscribe = gd.bus.subscribeNoContext(EVENT_BUS_LAYOUT_ON_WIDTH_MAIN_CHANGE, onResize)
            return () => {unsubscribe()}
        }
    }, [props.cover])

    debug && console.log(debug, 'render', props)

    if (!props.cover) {
        return null
    }

    const onTogglePopover = (value:boolean) => {
        setShowPopover(value)
    }

    const classes = Classes("cover-image", props.className, {
        'full-width': props.isFullWidth
    })

    const style = {
        height              : '{0}px'.f(Math.floor(gd.layout.heightMain * 0.2)), // 20% view height
        backgroundPosition  : props.cover.backgroundPosition,
        backgroundImage     : props.cover.backgroundImage
    }

    const actionsClasses = Classes("actions", {
        'show-popover': showPopover
    })

    return (
        <div className  = {classes}
             style      = {style}>

            {!props.disabled &&
                <div className={actionsClasses}>
                    <CoverPositionSelector className        = "with-bg m-r-10"
                                           value            = {props.cover.position}
                                           onSelect         = {props.onCoverPositionSelected}
                                           onTogglePopover  = {onTogglePopover}/>

                    <CoverSelector
                        enableAttachments = {true}
                        className         = "with-bg"
                        type              = 'label'
                        cover             = {props.cover}
                        attachments       = {props.attachments}
                        onSelect          = {props.onCoverSelected}
                        onTogglePopover   = {onTogglePopover}
                    />
                </div>}
        </div>
    )
}
